import StickyMenuController from "../_components/stickyMenu/StickyMenuController";

new StickyMenuController(document.querySelector('.js--element-stickyMenu'));